import {
  startOfMonth,
  subMonths,
  format,
  isValid,
  getDate,
  endOfMonth,
  eachWeekOfInterval,
} from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import {
  REVENUE_DATE_GROUP_TYPES,
  REVENUE_PERIOD_STATES,
  TWO_WEEKS_IN_DAYS,
} from 'constants/common'
import {
  DATE_DEFAULT,
  MONTH_DAY_SHORT,
  MONTH_WITH_YEAR_SHORT,
} from 'constants/datetime'

// Index of week is calculated based on all weeks in a specific interval
// We couldn't use date-fns getWeekOfMonth, because some weeks start in a previous month or end in a next month
const getWeekLabelWithinInterval = (date, interval) => {
  const everyWeekWithinInterval = eachWeekOfInterval(interval, {
    weekStartsOn: 1,
  })
  const dateTimestamp = format(date, DATE_DEFAULT)
  const index = everyWeekWithinInterval.findIndex(
    (dateToFind) => format(dateToFind, DATE_DEFAULT) === dateTimestamp
  )
  return `Week ${index + 1}`
}

export const getThisMonthGroupBy = (now) =>
  getDate(now) < TWO_WEEKS_IN_DAYS
    ? REVENUE_DATE_GROUP_TYPES.DAY
    : REVENUE_DATE_GROUP_TYPES.WEEK

export const dateToColumnLabel = (period, inputDate, convertDateToTimezone) => {
  const isoFormat = inputDate?.isoFormat

  if (!isoFormat) {
    return '-'
  }

  const date = utcToZonedTime(isoFormat, '')

  if (!isValid(date)) {
    return '-'
  }

  const now = convertDateToTimezone(new Date())

  if (period === REVENUE_PERIOD_STATES.LAST_MONTH) {
    return getWeekLabelWithinInterval(date, {
      start: subMonths(startOfMonth(now), 1),
      end: startOfMonth(now),
    })
  }

  if (period === REVENUE_PERIOD_STATES.ALL_TIME) {
    return format(date, MONTH_WITH_YEAR_SHORT)
  }

  if (
    period === REVENUE_PERIOD_STATES.THIS_MONTH &&
    getThisMonthGroupBy(now) === REVENUE_DATE_GROUP_TYPES.WEEK
  ) {
    return getWeekLabelWithinInterval(date, {
      start: startOfMonth(now),
      end: endOfMonth(now),
    })
  }

  return format(date, MONTH_DAY_SHORT)
}

export const PERIOD_DATE_GROUP_STATES = {
  [REVENUE_PERIOD_STATES.ALL_TIME]: ({ now, expertCreated }) => ({
    groupBy: REVENUE_DATE_GROUP_TYPES.MONTH,
    date: {
      from: startOfMonth(expertCreated),
      to: endOfMonth(now),
    },
  }),
  [REVENUE_PERIOD_STATES.LAST_MONTH]: ({ now }) => ({
    groupBy: REVENUE_DATE_GROUP_TYPES.WEEK,
    date: {
      from: subMonths(startOfMonth(now), 1),
      to: startOfMonth(now),
    },
  }),
  [REVENUE_PERIOD_STATES.THIS_MONTH]: ({ now }) => ({
    groupBy: getThisMonthGroupBy(now),
    date: {
      from: startOfMonth(now),
      to: endOfMonth(now),
    },
  }),
}

export const X_AXIS_DIAGONAL_PROPS = {
  angle: -45,
  height: 100,
  tickMargin: 25,
  interval: 0,
}

export const BAR_SIZE = {
  S: 20,
  M: 40,
  L: 60,
}

export const BASE_RADIUS = 10
export const BAR_CHART_CUP_RADIUS = [BASE_RADIUS, BASE_RADIUS, 0, 0]
